import React, { Component } from 'react';
import { Formik } from 'formik';
import { connect } from 'react-redux';
import { PageView } from '@jg/react-tracking';
import { withTranslation } from 'react-i18next';
import { Helmet } from 'react-helmet';
import JoinStepNaviagtionContainer from '../JoinStepNaviagtionContainer/JoinStepNaviagtionContainer';
import {
  getRequestError,
  getRequestInFlight,
} from '../../selectors/httpSelectors';
import {
  TGiftAid,
  IGiftAidFormProps,
  IGiftAidDispatchToProps,
  IGiftAidMapStateToProps,
} from './GiftAid.d';
import { IAppState, INewFrpData } from '../../types/state.d';
import {
  apiThunk as apiThunkAction,
  httpActions,
  appThunk as appThunkAction,
} from '../../actions';
import { ROUTES, REQUEST } from '../../consts';
import FatalError from '../../components/FatalError';
import GiftAidForm from '../../components/GiftAidForm';
import { getNewFrpData } from '../../selectors/appSelectors';

export class GiftAid extends Component<TGiftAid> {
  componentDidMount() {
    const { newFrpData, pushToPage } = this.props;

    if (!newFrpData.shortName) {
      pushToPage(ROUTES.FUNDRAISING_SETTINGS);
    }
  }

  handleSubmit = (giftAidData: IGiftAidFormProps) => {
    const { newFrpData, createFundraisingPage } = this.props;
    const {
      shortName: pageShortName,
      fundraisingTarget: targetAmount,
      gdprOptIn,
    } = newFrpData as Required<INewFrpData>;
    createFundraisingPage({
      pageShortName,
      targetAmount,
      gdprOptIn,
      giftAidData,
    });
  };

  render() {
    const { t, isError, resetRequestError, isInFlight } = this.props;
    return (
      <PageView
        trackingData={{
          subtype: 'join team',
          event_value: 'gift aid',
          page_section: 'join team > fundraising page creation > gift aid',
        }}
      >
        <Helmet title={t('title.join.createFRP.giftAid')} />
        <main data-qa="gift-aid-page">
          <JoinStepNaviagtionContainer />
          <Formik<IGiftAidFormProps>
            initialValues={{
              askingForDonation: false,
              contributingToCost: false,
              agreePolicies: false,
              readGuidanceNote: false,
            }}
            onSubmit={this.handleSubmit}
            render={
              /* istanbul ignore next */ formikProps => (
                <GiftAidForm {...formikProps} isInFlight={isInFlight} />
              )
            }
          />
          {isError && <FatalError closeButtonClick={resetRequestError} />}
        </main>
      </PageView>
    );
  }
}

export const mapDispatchToProps: IGiftAidDispatchToProps = {
  resetRequestError: httpActions.resetRequestError,
  createFundraisingPage: apiThunkAction.createFundraisingPage,
  pushToPage: appThunkAction.pushToPage,
};

export const mapStateToProps = (state: IAppState): IGiftAidMapStateToProps => ({
  isInFlight: getRequestInFlight(REQUEST.CREATE_FUNDRAISING_PAGE)(state),
  isError: getRequestError(REQUEST.CREATE_FUNDRAISING_PAGE)(state),
  newFrpData: getNewFrpData(state),
});

export default withTranslation()(
  connect(
    mapStateToProps,
    mapDispatchToProps,
  )(GiftAid),
);
